var map = {
	"./lang0.mp3": 1937,
	"./lang1.mp3": 1938,
	"./lang10.mp3": 1939,
	"./lang11.mp3": 1940,
	"./lang12.mp3": 1941,
	"./lang13.mp3": 1942,
	"./lang2.mp3": 1943,
	"./lang3.mp3": 1944,
	"./lang4.mp3": 1945,
	"./lang5.mp3": 1946,
	"./lang6.mp3": 1947,
	"./lang7.mp3": 1948,
	"./lang8.mp3": 1949,
	"./lang9.mp3": 1950
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1936;